module.exports = __webpack_public_path__ + "static/media/IMG_0811.e1d3a185.jpg";